import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const ProviderCardNotAccepting = ({
  display,
  phoneNumber,
  onlineSchedulingEnabled,
  reasonForVisitName,
}) => (
  <div className="padding-sm text-align-center">
    <h4 className="font-family-meta-bold margin-none">
      <FormattedMessage
        id="ProviderCardNotAccepting.header"
        defaultMessage="Please call us at {phoneNumber} to schedule your appointment with {display}."
        values={{
          display: <span className="text-nowrap">{display}</span>,
          phoneNumber: (
            <a href={`tel:${phoneNumber}`} className="text-nowrap">
              {phoneNumber}
            </a>
          ),
        }}
      />
    </h4>
    <p className="font-size-xs line-height-copy">
      {onlineSchedulingEnabled ? (
        <FormattedMessage
          id="ProviderCardNotAccepting.notAcceptingReasonForVisit"
          defaultMessage="{display} does not have any openings online for {reasonForVisitName} at the moment."
          values={{ display, reasonForVisitName }}
        />
      ) : (
        <FormattedMessage
          id="ProviderCardNotAccepting.onlineSchedulingDisabled"
          defaultMessage="{display} is not accepting appointments online at the moment."
          values={{ display }}
        />
      )}
    </p>
  </div>
);

ProviderCardNotAccepting.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  display: PropTypes.string.isRequired,
  onlineSchedulingEnabled: PropTypes.bool,
  reasonForVisitName: PropTypes.string.isRequired,
};

export default ProviderCardNotAccepting;
